import { render, staticRenderFns } from "./LoadListForm.vue?vue&type=template&id=5e10b572&scoped=true"
import script from "./LoadListForm.vue?vue&type=script&lang=js"
export * from "./LoadListForm.vue?vue&type=script&lang=js"
import style0 from "./LoadListForm.vue?vue&type=style&index=0&id=5e10b572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e10b572",
  null
  
)

export default component.exports